import type { Comment } from '../types';

export const commentsComparator = (a: Comment, b: Comment) => a.createdDate.valueOf() - b.createdDate.valueOf();
